/* eslint-disable jsx-a11y/anchor-is-valid */
import {FC} from 'react'
import {toAbsoluteUrl} from '../../../helpers'

type Props = {
  number: string
  title: string
  button: string
  // Optional navigation for the button. When provided, the button navigates; when omitted, the
  // card keeps its original inert `href='#'` behaviour (used for cards without a destination yet).
  onClick?: () => void
}

const Card6: FC<Props> = ({number, title, button, onClick}) => {
  return (
    <div className='card card-info h-100'>
      <div className='card-body d-flex justify-content-center text-center flex-column p-8'>
        <div style={{color: '#151515', fontSize: 18, fontFamily: 'Oswald', fontWeight: '500', wordWrap: 'break-word'}}>{number}</div>
        <div style={{width: '100%', textAlign: 'center', color: '#151515', fontSize: 12, fontFamily: 'Satoshi', fontWeight: '300', wordWrap: 'break-word'}}>{title}</div>   
        <a
          href='#'
          className='text-hover-primary d-flex flex-column'
          onClick={(e) => {
            if (onClick) {
              e.preventDefault()
              onClick()
            }
          }}
        >
            <div style={{color: '#151515', fontSize: 12, fontFamily: 'Oswald', fontWeight: '500', textTransform: 'uppercase', wordWrap: 'break-word',marginTop:'2px'}}>{button}</div>
        </a>
      </div>
    </div> 
    
  )
}

export {Card6}
